"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

// Source: /frontend/js/src/preact-components/assets/icon-link.tsx
var Link = function Link(props) {
  return (0, _preact.h)("svg", (0, _extends2.default)({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    role: "img",
    "aria-hidden": "true",
    focusable: "false"
  }, props), (0, _preact.h)("path", {
    d: "M3.25033 9.99998C3.25033 8.57498 4.40866 7.41665 5.83366 7.41665H9.16699V5.83331H5.83366C3.53366 5.83331 1.66699 7.69998 1.66699 9.99998C1.66699 12.3 3.53366 14.1666 5.83366 14.1666H9.16699V12.5833H5.83366C4.40866 12.5833 3.25033 11.425 3.25033 9.99998ZM6.66699 10.8333H13.3337V9.16665H6.66699V10.8333ZM14.167 5.83331H10.8337V7.41665H14.167C15.592 7.41665 16.7503 8.57498 16.7503 9.99998C16.7503 11.425 15.592 12.5833 14.167 12.5833H10.8337V14.1666H14.167C16.467 14.1666 18.3337 12.3 18.3337 9.99998C18.3337 7.69998 16.467 5.83331 14.167 5.83331Z",
    fill: "currentColor"
  }));
};

var _default = Link;
exports.default = _default;